import React, {useRef, useState} from "react";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import DateUtil from "utils/DateUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import UISelect from 'components/selectbox/UISelect';
import ModalPopup from "../../../../components/modal";
import useToggleState from "../../../../components/hooks/useToggleState";
import paramStore from "common/page/store/ParamStore";

function ContentsContainer() {
	const modaladm1214 = useToggleState({});
	const [modal2149IsOpen, setModal2149IsOpen] = useState(false);

	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const selectCorpJson = useRef<string>("");
	const paramJson = useRef<string>("");
	let pageNum = useRef<number>(1);
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(100); //기본 row count
	const [dateNum,setDateNum] = useState(0); //날짜 기본값


	const [totalRowCnt_modal,setTotalRowCnt_modal] = useState(0);
	const [showRowCnt_modal,setShowRowCnt_modal] = useState(50); //기본 row count


	/** 검색조건 */
	const [title,setTitle] = useState('');
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [donProcStsCd,setDonProcStsCd] = useState('');
	const [bizCd,setBizCd] = useState('');
	const [bizNo,setBizNo] = useState('');
	const [receipt,setReceipt] = useState('');
	const [handStsCd,setHandStsCd] = useState('');

	const [selectCorp,setSelectCorp] = useState<any>({});


	//팝업 검색 조건
	const [type,setType] = useState('CORP_NM');
	const [searchText,setSearchText] = useState('');

	async function onClose(num) {
		if(num == '2149'){
			setModal2149IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
		}
	}

	async function onAfterOpen(num) {

		ib_modal.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}

	}


	//초기 데이터 설정
	const rowCnt = useRef<string>("100");
	const rowCnt_modal = useRef<string>("100");
	const totalCnt = useRef<string>("");
	let defaultRowCnt = 20;


	//====== 그리드 공통 부 START
	var ib_modal = ib_modal||{};
	ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt_modal.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			/*"LeftCols": [
				{"Header": "No","Name": "RN","Width": "90"}
			],*/
			"Cols": [
				{"Header": "기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "법인등록번호","Type": "Text","Name": "CORP_REG_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0","CustomFormat": "######-#######"},
				{"Header": "사업자등록번호","Type": "Text","Name": "BIZ_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0","CustomFormat": "###-##-#####"},
				{"Header": "대표자","Type": "Text","Name": "CEO_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "규모","Type": "Text","Name": "CORP_SIZE_CD_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				doSearch('init', '2149');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					var row = sheet.getFocusedRow();
					setSelectCorp(row);
					setBizNo(row.BIZ_NO+'');
					onClose('2149');
				}
			},
			//시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
			onRenderFinish  :function(evtParam){



			},
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}


			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page, 'modal');
				}

				sheet.getDataRows().map(e => {
					e.Visible = 1;
					return e;
				})

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			if(receivedData !=undefined ){
				if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}

			//sheetId
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'modal_2149_List', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				//data: this.data // 생성될 시트의 정적데이터
			});


			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}





	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			"Cols": [
				{"Header": "NO","Type": "Int",	"Name": "SEQ",	"RelWidth": "0.5","Align": "Center","CanEdit": 0},
				{"Header": "상태","Type": "Html","Name": "HAND_STS_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0",
					"Format" : {
						'신청' : '<label class="badge badge-22 blue">신청</label>',
						'접수중' : '<label class="badge badge-22 yellow">접수중</label>',
						'반려' : '<label class="badge badge-22 red">반려</label>',
						'승인완료' : '<label class="badge badge-22 gray">승인완료</label>'
					}
				},
				{"Header": "출연기업","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "전용신청일자","Type": "Text","Name": "HAND_DATE","RelWidth": 2,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "출연일자/전용일자","Type": "Date","Name": "DON_DATE","RelWidth": 2,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "출연사업","Type": "Text","Name": "BIZ_NM1","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연금액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "전용사업","Type": "Text","Name": "BIZ_NM2","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "전용신청금액(원)","Type": "Int","Name": "HAND_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "전용금액(원)","Type": "Int","Name": "DON_AMT2","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('init', '1212');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					let sheet = evtParam.sheet;
					let row = sheet.getFocusedRow();
					sheet.selectRow( row, 1);

					let vHAND_NO= row["HAND_NO"].replaceAll('-', '');
					let vDON_NO = row["DON_NO2"];


					let dataToSend = {vHAND_NO,vDON_NO};

					// 다른 페이지로 이동하면서 데이터 전달
					
					paramStore.setParam("adm1213", dataToSend);

					history.push({
						pathname: './adm1213',
						state: { data: dataToSend }
					});
				}

			},
			//시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
			onRenderFinish : function(evtParam){
				if(receivedData !=undefined ){
					if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
    		},
			onAfterSort:function(evtParam){
				// @ts-ignore
				sheet.goToPageByIndex(1);
				if(evtParam.sheet.getShownRows().length != 0){
					// @ts-ignore
					sheet.focus(evtParam.sheet.getShownRows()[0], "SEQ");
				}
			},
			onMouseOver:function(evtParam){
				var sheet = evtParam.sheet;
				if (evtParam.row && evtParam.col && evtParam.orow && evtParam.ocol) {

					//console.log("이전 셀 값은 "+ sheet.getValue({row:evtParam.orow, col:evtParam.ocol}));
					//console.log("현재 셀 값은 "+ sheet.getValue({row:evtParam.row, col:evtParam.col}));
					//특정행의 글자를 붉은색으로 지정합니다..
					/*
					var row = evtParam.row;
					row["TextColor"] = "#297BF2";
					sheet.refreshRow(row);

					var oldrow = evtParam.orow;
					oldrow["TextColor"] = "#000000";
					sheet.refreshRow(oldrow);
					*/
				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					_data = JSON.stringify(d.slice(0, defaultRowCnt), null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}

			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page, 'ib');
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "전용관리_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib.create();


		//필요한 공통코드 로딩.
		//codeDataStore.read("/system.personmanage/utcAll", "/common/yesNo");

		codeDataStore.read(
			"[DPSC]", "cfms.portalBizCdList",
		)


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_CORP = selectCorpJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_CORP, PARAM_PAGE, PARAM_ROW_CNT};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1212',
			state: { data: dataToSend }
		});
	}

	const setSearchData = (type:string) => {
		let param:any = {};
		let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");

		param = {
			"ST_DATE":sDt,
			"EN_DATE":eDt,
			"BIZ_CD" : bizCd,
			"HAND_STS_CD" : handStsCd,
			"BIZ_NO" : bizNo
		};

		if(type == 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData != undefined && receivedData.PARAM_DATA != undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.ST_DATE != '') setStartDate(new Date(param.ST_DATE));
				if(param.EN_DATE != '') setEndDate(new Date(param.EN_DATE));
				if(param.BIZ_CD != '') setBizCd(param.BIZ_CD);
				if(param.HAND_STS_CD != '') setHandStsCd(param.HAND_STS_CD);

				if(receivedData.PARAM_CORP != '{}'){
					let corp = JSON.parse(receivedData.PARAM_CORP);
					setSelectCorp(corp);
					setBizNo(corp.BIZ_NO);
				}

				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		}else{
			pageNum.current = 1;
		}

		paramJson.current = JSON.stringify(param);
		selectCorpJson.current = JSON.stringify({ BIZ_NO : selectCorp.BIZ_NO, CORP_NM : selectCorp.CORP_NM });

		paramSetting();

		return param;
	}

	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string, actionId) {
		let param:any = {};
		let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");
		let url = '';


		if(actionId == '1212'){
			url = 'adm_1212';

			param = setSearchData(sAction);
		}else if(actionId == '2149'){
			param = {
				"BIZ_NO":'',
				"CORP_REG_NO":'',
				'CORP_NM': ''
			};
			param[type] = searchText;
			url = 'popup_search_corp';
		}


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:url,
			data: param
		})



		//전체데이터
		let result = response.REC;

		//전체ROW개수
		totalCnt.current = Object.keys(result).length+'';
		setTotalRowCnt(Object.keys(result).length);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		if(actionId == '1212'){
			//데이터 처리
			ib.data = result;


			// @ts-ignore
			sheet.loadSearchData(result);  //data 로딩 처리
			// @ts-ignore
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1, 'ib'); // 페이지 초기화
		}else{
			//데이터 처리
			ib_modal.data = result;


			// @ts-ignore
			sheet_modal.loadSearchData(result);  //data 로딩 처리
			// @ts-ignore
			sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(sheet_modal.getPageIndex( sheet_modal.getFocusedPage()) + 1, 'modal'); // 페이지 초기화
		}



	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, type) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			let elId = 'pageNavi';
			if(type == 'modal'){
				elId = 'modal_pageNavi';
			}

			// @ts-ignore
			if (document.getElementById(elId).firstChild) {
				// @ts-ignore
				document.getElementById(elId).removeChild(document.getElementById(elId).firstChild);
			}



			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			if(type == 'modal') page = rowCnt_modal.current;

			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(Number(sr) / Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, 1);
				else addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, tp - 1);
				else addEventHandler(li, 'click', pageMove, tp - 1);

				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);

					if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, i);
					else addEventHandler(li, 'click', pageMove, i);

					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, tp + 1);
				else addEventHandler(li, 'click', pageMove, tp + 1);

				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, lastpage);
				else addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';

			// @ts-ignore
			document.getElementById(elId).appendChild(ul);


		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}
	//페이지 이동
	// @ts-ignore
	const pageMove_modal = function (cPage:number) {
		// @ts-ignore
		sheet_modal.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search', '1212');
		}
	}

	async function SetDate(value){
		const newEndDate = new Date();
		setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
		const newStartDate = new Date(newEndDate);
		newStartDate.setDate(newEndDate.getDate() - value);
		setStartDate(newStartDate);  // 시작 날짜를 조정
	}

	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			receivedData.PARAM_ROW_CNT = e.target.value;
			rowCnt.current = e.target.value;
			pageNum.current = 1;

			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();

		}else if(e.target.name === 'showRowCnt_modal'){
			setShowRowCnt_modal(e.target.value);
			rowCnt_modal.current = e.target.value;
			// @ts-ignore
			ib_modal.disposeAll(true);
			ib_modal.init.Cfg.PageLength = e.target.value;
			ib_modal.create();

		}else if(e.target.name === 'selectType'){
			setType(e.target.value);
		}else if(e.target.name === 'receipt'){
			setReceipt(e.target.value);
		}else if(e.target.name === 'handStsCd'){
			setHandStsCd(e.target.value);
		}
	};



	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">기금관리</Link></li>
					<li><Link to="#">출연관리</Link></li>
					<li><Link to="#">전용관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">전용관리</h1>

					<div className="sf sf-2col">
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">처리기간</p>
								<div className="sf-value">
									<div className="hz-root hz-left hz-gap8">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={startDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={endDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-root hz-gap5">
											<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(90); setDateNum(1); } }>이전 3개월</Button>
											<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(180); setDateNum(2); } }>이전 6개월</Button>
											<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(365); setDateNum(3); } }>이전 12개월</Button>
											<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(730); setDateNum(4); } }>이전 24개월</Button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연기업</p>
								<div className="sf-value">
									<div className="hz-root hz-gap8">
										<UIInput className={'hz-item hz-fg tf tf-md tfNot'} value={selectCorp.CORP_NM} placeholder={''} readOnly={true} />
										<Button color="gray-o" size="md" onClick={() => {setModal2149IsOpen(true); }}>출연기업찾기</Button>
										<Button color="gray-o" size="md" onClick={() => { setSelectCorp({}); setBizNo('');  } }>삭제</Button>
									</div>

								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연사업</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">전용상태</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<select name={'handStsCd'} value={handStsCd}  onChange={(handleSelect)}>
											<option value="">전체</option>
											<option value="A">신청</option>
											<option value="B">접수중</option>
											<option value="D">반려</option>
											<option value="G">승인완료</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb30">
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={()=> doSearch('search', '1212')}>조회</button>
					</div>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>

					<div id='sheetDiv' >[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>

			{/* modal - 기업검색 */}
			<ModalPopup
				open={modal2149IsOpen}
				title="기업검색"
				size="mid"
				onClose={() => onClose('2149')}
				onAfterOpen={() => onAfterOpen('2149')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<div className="tb-search-form bd mb30">
							<div className="hz-root hz-center hz-gap8">
								<div className="hz-item sl sl-md">
									<select name={'selectType'} value={type} onChange={(handleSelect)}>
										<option value={"CORP_NM"}>기업명</option>
										<option value={"CORP_REG_NO"}>법인사업자번호</option>
										<option value={"BIZ_NO"}>사업자등록번호</option>
									</select>
								</div>
								<UIInput className={'hz-item tf tf-md'} value={searchText} valueChanged={(value) => setSearchText(value)} placeholder={"입력하세요."} />
								<Button color="pri" size="md" onClick={() => doSearch('search', '2149')}>조회</Button>
							</div>
						</div>

						<div className="tb-top">
							<div>
								<p className="tx fc-black">총 <em className="fw500">{totalRowCnt_modal}</em>건</p>
							</div>
							<div className="hz-root hz-gap8">
								<div className="sl sl-sm w120">
									<select name="showRowCnt_modal" id="showRowCnt_modal" value={showRowCnt_modal}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div id="modal_2149_List" >[D] IBSHEET 영역</div>
						<div id="modal_pageNavi" className="pg"></div>
					</div>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;